import {HostnameParts} from "./hostname-parts.ts";

/**
 * The request's current url in the desired language.
 *
 * If the language tag is None and the current hostname looks like
 * foo.khanacademy.org, use 'www' as the subdomain.
 *
 * There are some minor differences in behavior between this implementation
 * and the python implementation, namely:
 * - language tags in the URL a lowercased, e.g. es-es is used instead of es-ES
 * - bad language tags in the subdomain result in 'www' being the subdomain
 *
 * NOTE: the reason why we don't use kaLocale is that the kaLocale is 'en'
 *       for both foo.ka.org and en.ka.org, but we only want to redirect the
 *       first one to www.ka.org.
 *
 * @param {string} language_tag: the language to redirect to
 */
export const urlInLanguage = (languageTag: string, location: URL): string => {
    const hostnameParts = HostnameParts.parse(location.hostname);
    const encodedlanguageTag = encodeURIComponent(languageTag);
    hostnameParts.setLang(encodedlanguageTag);
    const domain = hostnameParts.domain();

    if (domain) {
        location.hostname = domain;
        return location.href;
    }

    location.searchParams.set("lang", languageTag);
    return `${location.pathname}${location.search}${location.hash}`;
};
